export default __webpack_public_path__ + "static/Novacom-ISO-9001-Certificate-2025-46b51ded3a893878169c211793350a03.pdf";